module.exports = {
          srcSet: __webpack_public_path__ + "f3c3ca75608df742a57e925e8286d362-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "f3c3ca75608df742a57e925e8286d362-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "f3c3ca75608df742a57e925e8286d362-60.png",
          toString:function(){return __webpack_public_path__ + "f3c3ca75608df742a57e925e8286d362-60.png"},
          
          width: 60,
          height: 60
        }